<div #animatedCounter>
  <span>{{ counterNum }}</span>
</div>
